define('shared/initializer/form/newHouseAdapters/mixins/CreditCardPayable',[
    'shared/lib/RSVP',
    'shared/remote/payment/creditCard/pay',
    'shared/page/market',
    'shared/page/partner',
    'shared/page/eTag',
    'shared/util/state',
    'shared/util/state/adapters/order',
    'shared/initializer/form/constants',
    'shared/util/checkout/PaymentMethodManager'
], 
function(
    RSVP,
    payCreditCard,
    getMarket,
    getPartner,
    getETag,
    state,
    orderAdapter,
    constants,
    PaymentMethodManager
){
    function Ctor() {}

    function getField($form, name) {
        return $form.find('[name="' + name + '"]');
    }

    Ctor.getCreditCardOptions = function($form) {
        var creditCardNumber = getField($form, constants.FIELD.CREDIT_CARD_NUMBER).val();
        var expirationMonth = getField($form, 'ExpirationMonth').val();
        var expirationYear = getField($form, 'ExpirationYear').val();
        var csc = getField($form, 'CardVerificationCode').val();
        var creditCardName = getField($form, constants.FIELD.CREDIT_CARD_FULLNAME).val();
        var creditCardGivenName = getField($form, constants.FIELD.CREDIT_CARD_FIRSTNAME).val();
        var creditCardFamilyName = getField($form, constants.FIELD.CREDIT_CARD_LASTNAME).val();

        if (creditCardName) {
            var tmp = creditCardName.split(' ');
            creditCardGivenName = tmp.shift();
            for(var l = tmp.length; l--;) {
                tmp[l] = tmp[l].trim();
            }
            creditCardFamilyName = tmp.join(' ');
            creditCardGivenName = creditCardGivenName.trim();
            creditCardFamilyName = creditCardFamilyName.trim();
        }

        return {
            number: creditCardNumber,
            name: {
                family: creditCardFamilyName,
                given: creditCardGivenName
            },
            expiration:  {
                year: expirationYear,
                month: expirationMonth
            },
            csc: csc
        };
    };

    function doActualSubmit() {
        var me = this;
        var $form = me.$form;
        var offers;
        var creditCardOptions;

        return RSVP.resolve()
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                return state.retrieve(constants.State.OrderOfferId);
            })
            .then(function(value){
                offers = value;
                if (!offers || offers.length <= 0) {
                    return RSVP.reject('No offer id specified');
                }
            })
            .then(function(){
                creditCardOptions = Ctor.getCreditCardOptions($form);
            })
            .then(function(){
                return RSVP.all([
                    getMarket(), 
                    getPartner(), 
                    getETag()
                ]);
            })
            .then(function(values){
                var market = values[0];
                var partner = values[1];
                var etag = values[2];

                return payCreditCard({
                    purchase: {
                        market: market,
                        partner: partner,
                        etag: etag,
                        offers: offers
                    },
                    creditCard: creditCardOptions
                });
            });
    }

    Ctor.prototype.doSubmit = function(data) {
        var me = this;

        return PaymentMethodManager.instance.get()
            .then(function(paymentMethod){
                if (paymentMethod === PaymentMethodManager.METHOD_TYPE_DEFAULT) {
                    return doActualSubmit.call(me);
                }
                else {
                    return data;
                }
            });

    };

    return Ctor;
});
